import { CommonPageName } from '../global';
export class NavigationHelper {
}
NavigationHelper.goBack = (router) => {
    router.go(CommonPageName.GoBack);
};
